import React from 'react';
import FileStackImage from 'misc/filestack_image';

const TemplateCardCoverImage = ({
  bssUploadId,
  bssSignedUrl,
  fileName,
  handle,
  policy,
  signature,
}) => {
  const filestackImage = new FileStackImage({
    signature,
    policy,
    handle,
    transform: {
      resize: {
        fit: 'crop',
        align: 'center',
        height: 167,
        width: 233,
      },
    },
  });

  const coverImageUrl = bssUploadId ? `'${bssSignedUrl}'` : filestackImage.url;

  return (
    <div className="TemplateCard-imageContainer">
      <div
        className="TemplateCard-image"
        style={{
          backgroundImage: `url(${coverImageUrl})`,
        }}
        alt={fileName}
        title="templateCoverImage"
      />
    </div>
  );
};

export default TemplateCardCoverImage;
